// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "ion-modal {\n  --backdrop-opacity: 0.5 !important;\n}\nion-modal::part(content) {\n  height: 380px;\n  max-height: calc(100vh - 96px);\n}\n\n.alert-text {\n  color: var(--ion-color-dark-shade);\n  margin-bottom: 16px;\n}\n\n.row-gap {\n  gap: 1rem;\n}\n\n.let-go-premium {\n  font-size: 20px;\n}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
